import Grid from '@material-ui/core/Grid';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';

import Collection from '../Model/Collection';

import ItemTableRow from '../Components/ItemTableRow';
import OrganizationGroupCard from '../Admin/Components/OrganizationGroupCard';
import OrganizationGroupCollectionFields from '../Model/OrganizationGroupCollectionFields';
import OrganizationGroupDialog from '../Admin/Components/OrganizationGroupDialog';
import OrganizationGroupCreationDialog from '../Admin/Components/OrganizationGroupCreationDialog';

import {
  GetOrganizationGroupsPathForApi,
  GetOrganizationGroupPathForApi,
} from '../Util/api';
import {
  GetOrganizationGroupsPath,
} from '../Util/PathHelper';
import {
  HandleRouteToOrganizationGroup,
} from '../Util/OrganizationGroups';

import API from '../Util/api';

import {
  GetDateValue,
} from '../Util/Properties';

export class OrganizationGroups_Collection extends Collection {
  constructor(props, onSetState, onApiError, organizationId, onItemTitleChange) {

    if (typeof organizationId !== "string") {
      console.log("Warning: organizationId required and not found");
    }
    super(props, onSetState, onApiError, false, false, organizationId);

    this.handleItemTitleChange = onItemTitleChange;

    this.PageTitle = "Organization Groups";
    this.ContentUri = GetOrganizationGroupsPathForApi(organizationId);
    this.CollectionName = "OrganizationGroups";
    this.ItemsName = "OrganizationGroups";
    this.ItemName = `Organization Group`;
    this.DefaultViewType = "List";
    this.AllowSelect = true;
    this.OrganizationGroupsForDialog = [];
  }

  HandleGetCollectionFieldsPromise = () => Promise.resolve(OrganizationGroupCollectionFields);

  HandleGetHeadCells = (items, sensitiveFields) => [
    { id: 'Name', sortId: 'Meta_text_kw256lc[Name].keyword', numeric: false, label: 'Name' },
    { id: 'CreatedOn', sortId: 'Meta_date_str256[CreatedOn].string', numeric: false, label: 'Created' },
  ];

  HandleGetCardGridItems = (items, sensitiveFields, classes, theme, onSelect, selectedIDs, onAction, postActionData, sortType, sortDescending) => {
    return (items && items.length)
      ? items
        .map(i => {
          return (
            <Grid item key={i.ID} sm={12} md={6} lg={4} xl={3} className={classes.cardGridItem}>
              <OrganizationGroupCard
                OrganizationGroup={i}
                onCardAction={() => HandleRouteToOrganizationGroup(this.props, this.OrganizationID, i.ID)}
                onSelect={() => onSelect(i.ID)}
                selected={selectedIDs.indexOf(i.ID) > -1}
              />
            </Grid>
          );
        })
      : [];
  }

  HandleGetTableRows = (headCells, items, sensitiveFields, classes, theme, onSelect, selectedIDs, onAction, postActionData, sortType, sortDescending) => {
    return (items && items.length)
      ? items
        .map(i => {
          const labelId = `label_${i.Name}`;
          return (
            <ItemTableRow key={`k_${i.ID}`}
              onItemClick={() => HandleRouteToOrganizationGroup(this.props, this.OrganizationID, i.ID)}
              onSelect={() => onSelect(i.ID)}
            >
              <TableCell className={classes.tableCell_FirstCell} padding="checkbox">
                <Checkbox
                  color="secondary"
                  onClick={event => { event.stopPropagation(); onSelect(i.ID); }}
                  checked={selectedIDs.indexOf(i.ID) > -1}
                  inputProps={{ 'aria-labelledby': labelId, style:{zIndex:0} }}
                />
              </TableCell>
              <TableCell className={classes.tableCell} component="th" id={labelId} scope="row" padding="none">
                {i.Name}
              </TableCell>
              <TableCell className={classes.tableCell}>{GetDateValue(i.CreatedOn)}</TableCell>
            </ItemTableRow>
          );
        })
      : [];
  }

  HandleItemsChanged = items => {
    this.OrganizationGroupsForDialog = items || [];
    this.handleDisplayOrganizationGroupDialogIfApplicable(null, items);
  }

  handleDisplayOrganizationGroupDialogIfApplicable = (organizationGroupId, organizationGroups) => {
    if (!organizationGroupId) {
      organizationGroupId = this.props.match.params.collectionItemID;
    }
    if (organizationGroupId) {
      const displayGroupDialog = (organizationGroup, extraState) => {
        this.setState({
          OrganizationGroupForOrganizationGroupDialog: organizationGroup,
          OrganizationGroupDialogIsOpen: true,
          ...extraState,
        });
        if (this.handleItemTitleChange) {
          this.handleItemTitleChange(organizationGroup.Name);
        }
      }
      if (!organizationGroups) {
        organizationGroups = [...this.OrganizationGroupsForDialog];
      }
      let groupFinder = organizationGroups.filter(g => g.ID === organizationGroupId);
      if (!groupFinder.length) {
        API.get(GetOrganizationGroupPathForApi(this.OrganizationID, organizationGroupId))
          .then(resp => {
            displayGroupDialog(resp.data, {
              ForcePrependItems: [resp.data],
            });
          })
          .catch(err => {
            this.handleApiError(err);
            this.handleOrganizationGroupDialogClosed();
          });
      } else {
        displayGroupDialog(groupFinder[0]);
      }
    }
  }

  handleOrganizationGroupDialogClosed = () => {
    const stateToUpdate = {
      OrganizationGroupDialogIsOpen: false,
      ShowDialogProgressIndicatorImmediately: false,
    };
    this.setState(stateToUpdate);

    const newPath = GetOrganizationGroupsPath(this.OrganizationID);
    if (this.props.location.pathname !== newPath) {
      this.props.history.push(newPath, { ...this.props.location.state, ...stateToUpdate });
    }
    if (this.handleItemTitleChange) {
      this.handleItemTitleChange(null);
    }
  }

  HandleGetDialogContent = state => {
    if (state.OrganizationGroupDialogIsOpen) {
      return (
        <OrganizationGroupDialog
          open={state.OrganizationGroupDialogIsOpen || false}
          OrganizationGroup={state.OrganizationGroupForOrganizationGroupDialog}
          onOrganizationGroupRevised={this.HandleItemRevised}
          onApiError={this.handleApiError}
          onClose={this.handleOrganizationGroupDialogClosed}
          showProgressIndicatorImmediately={state.ShowDialogProgressIndicatorImmediately}
        />
      );
    }
    else if (state.AddOrganizationGroupDialogIsOpen) {
      return (
        <OrganizationGroupCreationDialog
          organizationId={this.OrganizationID}
          open={state.AddOrganizationGroupDialogIsOpen || false}
          onCreated={this.handleOrganizationGroupCreated}
          onClose={() => this.handleAddOrganizationGroupDialogClosed()}
          onApiError={this.handleApiError}
        />
      );
    }
  }

  handleAddOrganizationGroupDialogClosed = () => {
    this.setState({
      AddOrganizationGroupDialogIsOpen: false,
    })
  }

  handleOrganizationGroupCreated = organizationGroup => {
    this.handleAddOrganizationGroupDialogClosed();
    if (!organizationGroup) {
      return;
    }
    this.setState({
      ForcePrependItems: [organizationGroup],
    });
  }

  HandleCreateNew = () => {
    this.setState({
      AddOrganizationGroupDialogIsOpen: true,
    });
  }

  // Returns whether further path changes can occur.
  updateProps(props) {
    Collection.prototype.updateProps.bind(this)(props);

    if (this.props.match.params.collectionItemID && !this.prevProps.match.params.collectionItemID) {
      this.handleDisplayOrganizationGroupDialogIfApplicable(null, null);
      return false;
    } else if (!this.props.match.params.collectionItemID && this.prevProps.match.params.collectionItemID) {
      this.handleOrganizationGroupDialogClosed();
      return false;
    }

    return true;
  }
}
